import { call, put, takeLatest } from "redux-saga/effects";
import AseguradoActions, {
  Types as AseguradoTypes,
} from "../../stores/asegurado/Actions";
import AseguradoService from "../../services/asegurado/AseguradoService";
import AuthService from "../../services/auth/AuthService";
import ResponseCode from "../../services/ResponseCode";

function* consultarAsegurado(request) {
  yield put(AseguradoActions.consultarAseguradoLoading());

  const {
    numeroSesion,
    queryAfiliado,
    queryDocumento,
    tipoDocumento,
    esPilotoSam,
    codigoEmpresa,
  } = request.payload;

  let numeroPlastico = queryAfiliado;

  if (esPilotoSam && queryDocumento) {
    const consultarPlasticoRequest = {
      tipoDocumento,
      numeroDocumento: queryDocumento,
      compania: codigoEmpresa,
    };

    const consultarPlasticoResponse = yield call(
      AseguradoService.consultarNumeroPlastico,
      consultarPlasticoRequest
    );

    if(!consultarPlasticoResponse?.data?.numeroPlastico){
      yield put(
        AseguradoActions.consultarAseguradoFailure({
          codigo: ResponseCode.NOT_FOUND.code,
          mensaje: ResponseCode.NOT_FOUND.message,
        })
      );
      return;
    }

    numeroPlastico = consultarPlasticoResponse?.data?.numeroPlastico;
  }

  const consultarAfiliadoRequest = {
    numeroPlastico,
  };

  const afiliadoResponse = yield call(
    AseguradoService.consultarAsegurado,
    AuthService.handleRequestSession(consultarAfiliadoRequest, numeroSesion)
  );

  if (
    !afiliadoResponse?.respuesta ||
    afiliadoResponse?.respuesta?.codigo === ResponseCode.SERVER_ERROR.code
  ) {
    yield put(
      AseguradoActions.consultarAseguradoFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message,
      })
    );
    return;
  }

  if (afiliadoResponse?.respuesta?.codigo !== ResponseCode.OK.code) {
    yield put(
      AseguradoActions.consultarAseguradoFailure(afiliadoResponse?.respuesta)
    );
    return;
  }

  const { compania, afiliado } = afiliadoResponse?.data;

  yield put(
    AseguradoActions.consultarAseguradoSuccess({
      compania,
      afiliado,
      queryAfiliado,
      tipoDocumento
    })
  );
}

function* limpiarDatosAsegurado() {
  yield put(AseguradoActions.limpiarDatosAseguradoLoading());

  yield put(AseguradoActions.consultarAseguradoSuccess({}));
}

const exportedArray = [
  takeLatest(AseguradoTypes.CONSULTAR_ASEGURADO, consultarAsegurado),
  takeLatest(AseguradoTypes.LIMPIAR_DATOS_ASEGURADO, limpiarDatosAsegurado),
];

export default exportedArray;
